import { connect } from 'react-redux';
import React, { PropTypes } from 'react';
import { Header, Form, Segment, Radio, Grid } from 'semantic-ui-react';
import {
  getInstallDate,
  getInitialDuration,
  getAutonamticRenewal,
  getNextRenewal,
  getErrors,
} from '../reducers/form';
import { updateData, fetchFormIfNeeded } from '../actions/form';
import { isFetching } from '../reducers/index';

export class General extends React.Component {
  componentWillMount() {
    this.props.fetchForm(this.props.contractId);
  }

  render() {
    const {
      startContractDate,
      initialDuration,
      automaticRenewal,
      nextRenewal,
    } = this.props;

    const contractDurationOptions = [
      {
        text: `1 an`,
        value: 1,
      },
      {
        text: `2 ans`,
        value: 2,
      },
      {
        text: `3 ans`,
        value: 3,
      },
      {
        text: `4 ans`,
        value: 4,
      },
      {
        text: `5 ans`,
        value: 5,
      },
    ];

    const renderInitialDuration = () => {
      const duration = contractDurationOptions.find(
        r => r.value === initialDuration
      );
      if (duration) {
        return duration.text;
      } else {
        return 'NC';
      }
    };

    const automaticRenewaRadioLabel = () => {
      return automaticRenewal ? 'Désactiver' : 'Activer';
    };

    if (!this.props.isFetching) {
      return (
        <Segment>
          <Header size="tiny">Rappel des informations du contrat</Header>
          <Grid columns={4} divided>
            <Grid.Row>
              <Grid.Column>
                <Form.Field>
                  <label>Début</label>
                  {startContractDate}
                </Form.Field>
              </Grid.Column>
              <Grid.Column>
                <Form.Field>
                  <label>Durée initiale</label>
                  {renderInitialDuration()}
                </Form.Field>
              </Grid.Column>
              <Grid.Column>
                <Form.Field>
                  <label>Prochain renouvellement</label>
                  {nextRenewal}
                </Form.Field>
              </Grid.Column>
              <Grid.Column>
                <Form.Field>
                  <label>Tacite reconduction annuelle</label>
                  <Radio
                    toggle
                    name="automaticRenewal"
                    label={automaticRenewaRadioLabel()}
                    checked={automaticRenewal}
                    onChange={this.props.updateAutomaticRenewal}
                  />
                </Form.Field>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Segment>
      );
    } else {
      return (
        <div
          className="ui active loading segment"
          style={{ minHeight: '180px' }}
        />
      );
    }
  }
}

General.propTypes = {
  installDate: PropTypes.string.isRequired,
  nextRenewal: PropTypes.string,
  initialDuration: PropTypes.number,
  automaticRenewal: PropTypes.bool.isRequired,
  updateAutomaticRenewal: PropTypes.func.isRequired,
  fetchForm: PropTypes.func.isRequired,
  isFetching: PropTypes.bool.isRequired,
};

const mapStateToProps = (state, ownProps) => ({
  installDate: getInstallDate(state),
  nextRenewal: getNextRenewal(state),
  initialDuration: getInitialDuration(state),
  automaticRenewal: getAutonamticRenewal(state),
  errors: getErrors(state),
  isFetching: isFetching(state),
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  fetchForm: id => dispatch(fetchFormIfNeeded(id)),
  updateAutomaticRenewal: (_, value) =>
    dispatch(updateData('generalInformations.automaticRenewal', value.checked)),
});

export default connect(mapStateToProps, mapDispatchToProps)(General);



// WEBPACK FOOTER //
// ./src/modules/saas/aast/case-contract/renew/components/General.js